import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { Wifi, WifiOff, Sync } from "@mui/icons-material";
import { useReservationsContext } from "../../reservations/contexts/ReservationsContext";
import { useBreakpoint } from "../../../hooks/useBreakpoint";

const WebSocketStatus: React.FC = () => {
  const { wsConnected, wsLatency } = useReservationsContext();
  const { isMobile } = useBreakpoint();

  const getStatusColor = () => {
    if (!wsConnected) return "error";
    if (wsLatency !== null && wsLatency > 1000) return "warning";
    return "success";
  };

  const getStatusIcon = () => {
    if (!wsConnected) return <WifiOff />;
    if (wsLatency !== null && wsLatency > 1000) return <Sync />;
    return <Wifi />;
  };

  const getStatusText = () => {
    if (!wsConnected) return "Sin conexión";
    if (wsLatency !== null && wsLatency > 1000) return "Lento";
    return "En vivo";
  };

  const getTooltipText = () => {
    if (!wsConnected) {
      return "Sin conexión en tiempo real. Los cambios pueden no aparecer inmediatamente.";
    }
    if (wsLatency !== null && wsLatency > 1000) {
      return `Conexión lenta (${wsLatency} ms). Los cambios pueden retrasarse.`;
    }
    if (wsLatency !== null) {
      return `Conexión en tiempo real activa (${wsLatency} ms).`;
    }
    return "Conexión en tiempo real activa.";
  };

  return (
    <Tooltip title={getTooltipText()} arrow>
      {isMobile && wsConnected ? (
        <Box
          sx={(theme) => ({
            width: 28,
            height: 28,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color:
              getStatusColor() === "warning"
                ? theme.palette.warning.main
                : theme.palette.success.main,
            border: "1px solid",
            borderColor:
              getStatusColor() === "warning"
                ? theme.palette.warning.main
                : theme.palette.success.main,
          })}
        >
          {getStatusIcon()}
        </Box>
      ) : (
      <Chip
        icon={getStatusIcon()}
        label={getStatusText()}
        color={getStatusColor()}
        variant="outlined"
        size="small"
        sx={{
          "& .MuiChip-icon": {
            fontSize: 16,
          },
          fontSize: 12,
          height: 28,
        }}
      />
      )}
    </Tooltip>
  );
};

export default WebSocketStatus;
